import ButtonSmall from '@/components/ButtonSmall';
import styled from 'styled-components';

export const Button = styled(ButtonSmall)`
  height: 30px;
  align-self: flex-start;
`;
